module.exports = __webpack_public_path__ + "static/img/fish.4798839.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/projectImg/fish.png
// module id = q5M+
// module chunks = 1